module.exports = __webpack_public_path__ + "img/CM-MC-25-Volvo-Modern.e2f58ef3.jpg";